var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4"},[_c('base-typography',{staticClass:"required mb-1",attrs:{"value":_vm.label,"single":"","small":""}}),_c('base-typography',{staticClass:"mx-2",attrs:{"value":_vm.value,"single":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }